import Vue from 'vue';
import { WALLET_INITIAL_LOAD_TRANSACTION_NUMBER } from 'Config/constans';
import {
  SET_ALL,
  UPDATE_PROFILE_DATA,
  SET_TRANSACTION_DATA,
  ADD_TRANSACTION_DATA,
  LESS_TRANSACTION_DATA,
  SET_TRANSACTION_STATUS_CANCELLED,
  UPDATE_INVESTMENT_PROFILE_DATA,
  SET_PROFILE_SSN,
  DELETE_INVESTMENT_PROFILE,
} from './mutation-types';

export default {
  [SET_ALL](state, data) {
    Object.assign(state, data);
    return state;
  },
  [UPDATE_PROFILE_DATA](state, profileData) {
    Object.assign(state.profileData, profileData);
    return state.profileData;
  },
  [UPDATE_INVESTMENT_PROFILE_DATA](state, { data, profileId }) {
    if (!data) return;
    const profile = state.investmentProfileList.find(item => item.id === profileId);
    if (!profile) return;
    Object.entries(data).forEach(([key, value]) => {
      Vue.set(profile, key, value);
    });
  },
  [SET_TRANSACTION_DATA](state, data) {
    state.walletTransactionsData = data;
    return state.walletTransactionsData;
  },
  [ADD_TRANSACTION_DATA](state, data) {
    state.walletTransactionsData = state.walletTransactionsData.concat(data);
    return state.walletTransactionsData;
  },
  [LESS_TRANSACTION_DATA](state) {
    const walletTransactionsData = state.walletTransactionsData.splice(
      0,
      WALLET_INITIAL_LOAD_TRANSACTION_NUMBER,
    );
    Object.assign(state, { walletTransactionsData });
    return state.walletTransactionsData;
  },
  [SET_TRANSACTION_STATUS_CANCELLED](state, id) {
    const walletTransactionItem = state.walletTransactionsData.find(item => item.id === id);
    if (walletTransactionItem) Vue.set(walletTransactionItem, 'status', 'cancelled');
    return state;
  },
  [SET_PROFILE_SSN](state, { profileId, ssn }) {
    const ssnObject = state.investmentProfileSSNList.find(item => item.profileId === profileId);
    if (ssnObject) {
      Object.assign(ssnObject, { ssn });
    } else {
      state.investmentProfileSSNList = state.investmentProfileSSNList.concat({ profileId, ssn });
    }
    return state.investmentProfileSSNList;
  },
  [DELETE_INVESTMENT_PROFILE](state, profileId) {
    state.investmentProfileList = state.investmentProfileList.filter(profile => profile.id !== profileId);
    return state.investmentProfileList;
  },
};
